export default __webpack_public_path__ + "static/media/Carrusel_03.578f2d0c.png";